/* import '../styles/App.css';
 */import '../styles/Login.css'
import { useEffect, useState } from 'react';
import { TextField, Button, Divider, Typography } from "@material-ui/core"
import BackendAPI from "../API/BackendAPI"
import { useHistory } from 'react-router-dom';


import cookie from 'react-cookies'

const Login = ({
  handleLogin,
  userConnected,
  handleDisconnectApp
}) => {

  const history = useHistory()

  const [user, setUser] = useState(userConnected)
  const [error,setError]=useState(null)

  const handleConnect = async (e) => {
     e.preventDefault() 
    const response = await BackendAPI.login(dataConnection)
    // console.log(dataConnection)
    // console.log(response.connectionApprouvee)
    if (response!==null && response.connectionApprouvee) {
      setError(null)
      setUser(response.admin)
      
    } else {
      setError("erreurConnexion")
      handleLogin(null)
    }
  }

  useEffect(() => {
    
    if (user != null ) {
      if(cookie.load('user')!=="disconnected"){
        if(cookie.load('user')!=null ) cookie.remove('user')
        cookie.save('user', user, { 
          path: '/',
          maxAge: 60*60*1.5, //sec
        })
        handleLogin(user)
        if (user.username.toUpperCase().includes("ADMIN")) {
          // console.log(user)
          history.push("/admin-etudiants");
        }
      }else{
        setUser(null)
        cookie.remove('user', { path: '/' })
        handleDisconnectApp()
      }
      

    }
  }, [user])

    const [dataConnection, setDataConnection] = useState({
      username: "",
      password: "",
    });
  
    const onChange = (e) => {
      setError(null);
      setDataConnection((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    };
  
   
  
    return (
      <div className="body-login">
        <Typography variant="h1" color="primary">
          Connexion
        </Typography>
  
        <div className="login-image-container" style={{ maxHeight: 500 }}>
          <img
            style={{ width: "30%", objectFit: "contain" }}
            src="./assets/Login_Alice.png"
            alt="Login Illustration"
          />
          <Divider orientation="vertical" flexItem />
          <form method="post" className="login-form" onSubmit={handleConnect}>
            <TextField
              required
              label="Identifiant"
              variant="outlined"
              name="username"
              value={dataConnection.username}
              onChange={onChange}
              className="login-field"
              color="primary"
              inputProps={{ style: { fontSize: 16  } }}
              InputLabelProps={{ style: { fontSize: 16  } }}
            />
            <TextField
              required
              label="Mot de passe"
              variant="outlined"
              name="password"
              value={dataConnection.password}
              onChange={onChange}
              type="password"
              className="login-field"
              color="primary"
              inputProps={{ style: { fontSize: 16  } }}
              InputLabelProps={{ style: { fontSize: 16  } }}
              onKeyUp={(event) => {
                if (!event.ctrlKey && event.key === "Enter") {
                  handleConnect(event);
                }
              }}
            />
  
            <div className="login-buttons-container">
              {/* <Button
                variant="contained"
                onClick={() => history.push("/")}
                className="login-button retour"
                color="default"
                disabled={false} // Désactivé à `true` dans le code original, ici je mets `false` si ce n'est pas voulu
              >
                Retour
              </Button> */}
              <Button
                variant="contained"
                type="submit"
                className="login-button connect"
                color="primary"
              >
                Se connecter
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  };
  
  


export default Login;
